import mock from './mockAdapter';

import './apps/ecommerce';
import './apps/notes';
import './headerData';

mock.onAny().passThrough();
